import type { ConsentTracking } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetConsentTracking } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"
import { useConsentsSWRKey } from "./useConsentsSWRKey"

export function useConsents(): SWRResponse<ConsentTracking> {
  const consentsSWRKey = useConsentsSWRKey()
  const getConsents = useGetConsentTracking()

  const getConsentsData = useMemo(
    () => !getConsents
      ? null
      : async () => {
        const response = await getConsents()
        return response.data.consent_tracking
      },
    [getConsents],
  )

  return useSWR<ConsentTracking>(
    consentsSWRKey,
    getConsentsData,
  )
}
